import { createContext } from 'react';
import { ToastProps } from './types';

interface ToastContext {
    toastList: ToastProps[];
    setToastList(value: ToastProps[]): void;
    addToast(toast:ToastProps):void;
    removeToast(toastId:string):void;
}

export default createContext<ToastContext>({} as ToastContext);
